import { Component, EventEmitter, Input, OnInit, Output,HostListener } from '@angular/core';
import * as moment from 'moment';
import { TimeRemainingPipe } from '../../pipes/TimeRemaining.pipe';
import { Observable, Subscription, interval } from 'rxjs';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';

@Component({
  selector: 'timer',
  templateUrl: './timer.component.html',
  styles: [
  ]
})
export class TimerComponent implements OnInit {
  @Input() time: any
  @Input() type: "date" | "seconds" = "seconds"
  @Input() Mode: 'light' | "red" | 'dark' = 'light'
  @Input() auctionData: any;
  // 1==> start in 
  // 2==> end in 
  // 3==> Finished
  @Input() startORend: 1 | 2 | 3 = 1
  @Input() getRemainingFromSocket:number | undefined;
  @Input() IsRoom: boolean = false;

  @Output() LessThan10Second: EventEmitter<number> = new EventEmitter<number>();
  @Output() TimerEnded: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() RemainingTime: EventEmitter<number> = new EventEmitter<number>();
  expirationDate: any = interval(1000);
  expired = false;
  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;
  lable: string = ''
  modeClass: string = "timer_light"
  subscription: Subscription[] = [];
  getScreenWidth: number = window.innerWidth;


  constructor(private TimeRemaining: TimeRemainingPipe, public socket: SocketService) {
    this.socket?.socket?.on('getRemaining', (data: any) => {
      this.time = data;
       this.unsubscribeTimer();
       this.counter(this.time);

    })
    // alert(this.auctionData);
  }

  @HostListener('document:visibilitychange', ['$event'])
  visibilityChange(): void {

    if (document.hidden) {

    } else { 
      if(this.auctionData && this.startORend == 1){
        this.socket?.socket?.emit("getRemaining", this.auctionData.id);
      }

     
     
    }
  }

  ngOnInit(): void {
    
    this.visibilityChange();
    // this.TimeRemaining.output.subscribe((value: number) => {
    //   debugger
    //   console.log("HEEEEEEEEEEEEEEER ======== > " + value);
    //   this.LessThan10Second.emit(value)
    // })
    // this condition for add time if comming time contain only date withou time when using this component in for view room
    //  when be upcoming room 
    if (this.startORend == 1 && moment(this.time, "YYYY-MM-DD", true).isValid()) {
      this.time += "T00:00:00Z";
      this.time = moment().format(this.time);
    }
    //  when be ongoing room
    else if (this.startORend == 2 && moment(this.time, "YYYY-MM-DD", true).isValid()) {
      this.time += "T20:59:59Z"
    }



    switch (this.startORend) {
      case 1:
        this.lable = "timer.Starts in"
        break;
      case 2:
        this.lable = "timer.Ends in"
        break;
      default:
        this.lable = "timer.Starts in"
        break;
    }


    switch (this.Mode) {
      case 'light':
        this.modeClass = "timer_light"
        break;
      case 'dark':
        this.modeClass = "timer_dark"
        break;
      case 'red':
        this.modeClass = "timer_red"
        break;
      default:
        this.modeClass = "timer_light"
        break;
    }
    if(this.getRemainingFromSocket == 1 ){
      
      this.counterFromSocket(this.time);
    }else{
      this.counter(this.time);
    }
    

  }


  counterFromSocket(futureDate: number) {
    
    if (futureDate == 0) {
      // clearInterval(this.expirationDate);
      this.expired = true;
      this.TimerEnded.emit(true)
      return;
    }
    const timeRemaining = (futureDate * 1000);
    this.days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((timeRemaining % (1000 * 60)) / (1000));


  }

  counter(futureDate: any) {
    let Diff_GMT = new Date().getTimezoneOffset() * 60 * 1000;
    let timeRemaining = (futureDate * 1000);

    if (this.IsRoom) {
      timeRemaining = timeRemaining + Diff_GMT
    }
    this.subscription.push(this.expirationDate.subscribe(() => {
      // console.log("object");
      // let now = new Date().getTime();
      // let endDate = Time.getTime();
      // let timeRemaining = Time;   
      this.days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((timeRemaining % (1000 * 60)) / (1000));

      // if (this.days == 0 && this.hours == 0 && this.minutes == 0 && this.seconds <= 60 && !this.expired) {
      //   this.LessThan10Second.emit(this.seconds)
      // }



      if (timeRemaining <= 0) {
        // clearInterval(this.expirationDate);
        this.unsubscribeTimer()
        this.expired = true;
        this.TimerEnded.emit(true)
      }

   
      timeRemaining = timeRemaining - 1000
      //Last 5 minutes fire this event
      if (timeRemaining <= (5 * 60 * 1000)) {
        this.RemainingTime.emit(timeRemaining/1000);
      }
    })
    )

  }

  ngOnChanges(changes: any): void {
    // debugger
    if (changes?.time?.currentValue && !changes?.time?.firstChange) {
      // console.log("OnChange in Timer");
      if(this.getRemainingFromSocket == 1 ){
      
        this.counterFromSocket(this.time);
      }else{
        this.unsubscribeTimer();
        this.counter(changes?.time?.currentValue)
      }
     
    }

  }



  unsubscribeTimer() {
    if (this.subscription) {
      this.subscription.forEach(element => {
        element.unsubscribe();
      });
      this.subscription = []

      // this.days = 0;
      // this.hours = 0;
      // this.minutes = 0;
      // this.seconds = 0;
    }
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.subscription) {
      this.subscription.forEach(element => {
        element.unsubscribe();
      });
      this.subscription = []
    }
  }


  onWindowResize(event: any) {
    this.getScreenWidth = event.target.innerWidth;
  }
}
